
function jsonResponse(data) {
  return new Response(JSON.stringify(data), {
    headers: { "Content-Type" : "application/json" }
  })
}

async function fixtureTest() {

  await caches.open("api_with_dependencies_strategy").then(async (cache) => {
    // return cache.add('/api/v1/poi_contact');
    // const res = new Request("/api/v1/poi_contact")

    // store list w/ deps
    const resp = await fetch('/api/v1/poi_contact');
    await cache.put('/api/v1/poi_contact', resp.clone())

    const poi_json_cache = await caches.open("poi_json");
    const uploads_cache = await caches.open("uploads");

    const json = await resp.json();
    const promises = json.data.slice(0, 3).flatMap(x => [
        poi_json_cache.add(`/api/v1/poi_contact/${x.id}`),
        uploads_cache.add(x.img)
    ])

    return Promise.all(promises);
  })

  const id = 250;

  // fake insert in /api/v1/poi_contact;
  const p1 = await caches.open("poi_json").then(cache => {
    return cache.put(
      new Request(`/api/v1/poi_contact/${id}`),
      jsonResponse({id})
    )
  })

  const default_resp = await fetch("/app_config/img/default_contact_image");

  const p2 = caches.open("uploads").then(cache => {
    cache.put(
      new Request(`/uploads/abcd?type=contact&id=${id}`),
      default_resp
    )
  })

  await Promise.all([p1, p2]);
}


async function cleanContactDependencies() {
  const json = await caches.open("api_with_dependencies_strategy").then(cache =>
    cache.match("/api/v1/poi_contact").then(resp => resp.json())
  );
  const contact_ids = json.data.map(x => ""+x.id);

  const uploads_cache = await caches.open("uploads");

  // uploads are of the form ?type=<type>&id=<id>
  const to_delete_uploads = await uploads_cache.keys().then(keys => {
    return keys.filter(req => {
      const [,id] = req.url.match(/\?type=contact&id=(\d+)$/) || [];
      // we have a contact with an id but it's not included
      return id && !contact_ids.includes(id);
    })
  })

  console.log("to_delete_uploads", to_delete_uploads);

  const poi_json_cache = await caches.open("poi_json");

  // json are of the form /poi_contact/<id>
  const to_delete_json = await poi_json_cache.keys().then(keys => {
    return keys.filter(req => {
      const [,id] = req.url.match(/\/poi_contact\/(\d+)$/) || [];
      // we have a contact with an id but it's not included
      return id && !contact_ids.includes(id);
    });
  })

  console.log("to_delete_json", to_delete_json);

  await Promise.all(
    to_delete_uploads.map(k => uploads_cache.delete(k)).concat(
      to_delete_json.map(k => poi_json_cache.delete(k))
    )
  ).then(()=> console.log("DONE CLEARING CACHE: " + "for contacts"))
}


function cleanDependencies() {
  cleanContactDependencies();
}


// window.cleanDependencies = cleanDependencies;
// window.fixtureTest = fixtureTest;


export default cleanDependencies;
